import { render, staticRenderFns } from "./hzOffer.vue?vue&type=template&id=82966c20&scoped=true&"
import script from "./hzOffer.vue?vue&type=script&lang=js&"
export * from "./hzOffer.vue?vue&type=script&lang=js&"
import style0 from "./hzOffer.vue?vue&type=style&index=0&id=82966c20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82966c20",
  null
  
)

export default component.exports